import type { FaireProductEntity } from "../../entity_types/product";

export const p_ga86ayzj2b: FaireProductEntity = {
  token: "p_ga86ayzj2b",
  type: "product",
  name: "Unscented Castile Soap | Bulk Natural Castile Soap (64 oz)",
  brandToken: "b_5m0ewx9kld",
  brandName: "Elemental Wellness | Soap & Toxin-Free Living",
  imageUrl:
    "https://cdn.faire.com/fastly/610fec26c2d3961398fa1a60bdcf845cfd1f7da17959b5e32271be56bb4d5c3a.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7ee4adffeb05d83721be0398c25fc702604d8c9226790f8c69c3f600dadf9211.jpeg",
    "https://cdn.faire.com/fastly/f4a6b1dad06345d9d1e36fc60037c599631c82485199c15d54c19da9997d4e20.jpeg",
    "https://cdn.faire.com/fastly/fbc971ca2c23f4121b6686d55e79be2d57337d3b4bf257c6dc7257b9f6c750f6.jpeg",
    "https://cdn.faire.com/fastly/47b4ecc91aa2b3b6eaad087884047170680af39c93ce19850397e1ea9f106bc0.jpeg",
    "https://cdn.faire.com/fastly/4b7425815dd7c09dcda6bbc94de8364fd435d32876354d8f7606e7f9ff9e822b.jpeg",
    "https://cdn.faire.com/fastly/781e706281d1a25ffea37c4fffcea1446c7d608f75343abd6bc149fce1e6b0ec.jpeg",
    "https://cdn.faire.com/fastly/cb434f7227054ab044fa1b910a9a4813e94970d5377382577c017273b36b5244.jpeg",
  ],
  priceDollars: 28.17,
  description:
    "64 oz Unscented Soap — Clean Without Compromise.\n\nMade for sensitive skin, natural living, and microbiome-friendly hygiene.\n\nOur unscented castile soap (64 oz size) is:\n\n*Infused with skin-loving probiotics\n*Gentle, nourishing, and deeply cleansing\n*Free from synthetic fragrances, dyes, and toxins\n*Made with organic oils and pure essential oils\n*Multi-use: hands, body, face, even safe for babies\n*Handmade in small batches\n*Packaged in recyclable, eco-conscious bottles\n\nElemental Wellness exists to make toxin-free living easy, effective, and affordable—because protecting your body shouldn’t mean poisoning it.\n\nThis is: Probiotic castile soap, natural liquid soap, toxin-free body wash, microbiome-friendly soap.\n\nPeople also search for: Organic body wash, gentle soap for eczema, baby-safe soap, unscented castile soap, non-toxic hand soap.\n\nPerfect for: Daily showers, baby baths, handwashing, and anyone craving clean without the chemicals.",
  tags: [],
  msrpDollars: 46.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:49.696Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
